export default __webpack_public_path__ + "static/media/openraise_0006_thumb.a6e7b250.jpg";